module.exports = __webpack_public_path__ + "media/public/fonts/QanelasBold/QanelasBold-40cd99934317a5a45ffa1172a1c7728c.otf";